import { useFormatNumber } from '@dreamstack/i18n'
import type { Media } from '@dreamstack/payload/src/payload-types'
import last from 'lodash/last'
import { useMemo } from 'react'

const formatNumberOptions = { maximumFractionDigits: 1 }

type MediaFile = Pick<
  Media,
  'title' | 'mimeType' | 'filename' | 'filesize' | 'url'
>

export const useFormattedFile = (file?: MediaFile | null) => {
  const format = useFormatNumber(formatNumberOptions)
  return useMemo(() => {
    if (!file || !file.filename) return
    const safeSize = file?.filesize || 0
    const formattedFileSize = format(safeSize / 1000 / 1000) + 'MB'
    const formattedFileType = last(file?.filename.split('.'))

    return { formattedFileSize, formattedFileType }
  }, [file, format])
}
